import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, Popconfirm, Icon, Tooltip } from "antd";
import { Route, Switch } from "react-router-dom";

import List from "../../components/List";
import {
    bulkDelete,
    createResource,
    deleteResource,
    fetchResource,
    getResource,
    getResourceForDownload,
    saveResourceQuery,
    updateResource,
} from "../../appRedux/actions/Fuel";
import {
    fetchFilter,
    fetchFuelReportData,
    fetchRelationshipSearchData,
} from "../../appRedux/actions";
import {
    faviconDynamicFunction,
    getColumnSearchProps,
    getRenderForFieldByType,
    sanitizeFieldName,
} from "../../util/methods";
import AccessControl from "../../components/AccessControl";
import * as _ from "lodash";
import Refuel from "./refuel";
// import MileageReport from "./report/mileage-report";
import AssetMileageReport from "./report/asset-mileage-report";
import FuelSummeryReport from "./report/summery-mileage-report";
import LightBox from "../../components/LightBox";
import FuelChart from "./chart/index"
import RefuelReport from "./report/refuel-report";
import GroupChart from "./chart/group-chart";
import BowserTransactionReport from "./report/bowser-transaction-report";
import BowserReport from "./report/bowser-report";
import FuelStockIssueReport from "./report/fuel-stock-issue-report";

export class Fuel extends Component {
    initialQueryState = {
        sort: {
            field: "",
            order: "",
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
        filters: {},
    };

    state = {
        fields: {
            name: {
                value: "",
            },
            description: {
                value: "",
            },
        },
        query: this.initialQueryState,
        columns: [],
        visibleColumns: [],
    };

    constructor(props) {
        super(props);
        props.saveResourceQuery(this.initialQueryState);
    }

    componentDidMount() {
        // Get the current path after the base URL
        const currentPath = this.props.location.pathname.replace(this.props.match.url, '')

        // List of routes that don't need the list data
        const excludedRoutes = [
            '/refuel-report',
            '/mileage-report',
            '/summery-report',
            '/fuel-group-chart',
            '/bowser-transaction-report',
            '/bowser-report',
            '/stock-issue-report'
        ]
        // Only fetch if we're not on an excluded route
        if (!excludedRoutes.some(route => currentPath.startsWith(route))) {
            this.fetchList()
            this.props.fetchFilter(this.props.resourceName)
        }

        // this.fetchList();
        // this.props.fetchFilter(this.props.resourceName);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.filters._id &&
            this.props.filters._id !== nextProps.filters._id
        ) {
            const columns = Object.keys(nextProps.filters).filter((filter) =>
                Boolean(
                    nextProps.filters[filter].options &&
                    nextProps.filters[filter].options.column,
                ),
            );
            // columns.splice(2, 0, 'ownerCode');
            this.setState({ visibleColumns: [...columns, ...['ownerCode', 'mileage']] }, () => {
                this.renderColumns(nextProps.filters, this.state.visibleColumns);
            });
        }
    }

    handleColumnChange = (value, array) => {
        const { filters } = this.props;
        this.renderColumns(filters, value);
    };

    handleFilter = (selectedKeys, confirm, data) => {
        const query = { ...this.props.query };
        query.filters[data.field] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.field,
        });
        this.props.saveResourceQuery(query);
        confirm();
        this.fetchList();
    };

    handleReset = (clearFilters, data) => {
        const query = { ...this.props.query };
        delete query.filters[data.field];
        this.props.saveResourceQuery(query);
        clearFilters();
        this.fetchList();
    };

    handleChange = (pagination, filters, sorter) => {
        const query = { ...this.props.query };
        query.pagination = { ...query.pagination, current: pagination.current };
        query.sort = sorter;

        this.props.saveResourceQuery(query);
        this.fetchList();
    };

    handleFormChange = (changedFields) => {
        this.setState(({ fields }) => ({
            fields: { ...fields, ...changedFields },
        }));
    };

    renderColumns = (filters, selectedColumns) => {
        filters = filters || this.props.filters;
        const columns = [];
        const { resourceName } = this.props;

        columns.push({
            title: 'Photo',
            dataIndex: 'photo',
            key: 'photo',
            render: (_, record) => <LightBox photos={record && record.photos} id={record._id} />,
            width: 100,
        });

        if (selectedColumns.indexOf('ownerCode') >= 0) {
            const ownerCodeFilter = {
                field: 'asset',
                type: 'ObjectID',
                options: {
                    ref: 'Asset',
                    main: 'ownerCode',
                },
            };
            columns.push({
                title: sanitizeFieldName('ownerCode'),
                dataIndex: 'ownerCode',
                key: 'ownerCode',
                sorter: true,
                render: (_, record) => record.asset && record.asset.ownerCode || '-',
                ...getColumnSearchProps(
                    ownerCodeFilter,
                    this.handleFilter,
                    this.handleReset,
                    resourceName,
                ),
            })
        }

        Object.keys(filters).forEach((item) => {
            if (item === "_id") {
                return;
            }

            if (selectedColumns.indexOf(item) === -1) {
                return;
            }
            if (item === "date") {
                columns.push({
                    title: sanitizeFieldName(item),
                    dataIndex: filters[item].field,
                    sorter: true,
                    render: (value) =>
                        getRenderForFieldByType(value, filters[item].type, item, true),
                    ...getColumnSearchProps(
                        filters[item],
                        this.handleFilter,
                        this.handleReset,
                        resourceName,
                    ),
                });
                return;
            } else if (item === "mileage") {
                columns.push({
                    title: "Is Faulty Meter",
                    dataIndex: "isFaultyMeter",
                    // sorter: true,
                    render: (_, record) => {
                        // console.log(record && record.mileage)
                        const faultMeterRecord = (record.mileage || []).some(m => m && m.isFaultyMeter)
                        return faultMeterRecord ? <Tooltip title="True"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
                            <Tooltip title="False"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>;
                    },
                });
            }

            columns.push({
                title: item === "mileage"
                    ? "Meter Reading"
                    : item === "isFullTank"
                        ? "Considered as Full Tank"
                        : sanitizeFieldName(item),
                dataIndex: filters[item].field,
                sorter: true,
                render: (value) =>
                    getRenderForFieldByType(value, filters[item].type, item),
                ...(item === "mileage" ? {} : getColumnSearchProps(
                    filters[item],
                    this.handleFilter,
                    this.handleReset,
                    resourceName,
                )),
            });
        });

        columns.push({
            title: "Action",
            key: "action",
            render: (record) => (
                <div>
                    <AccessControl
                        resource={this.props.resourceName}
                        permissionNeeded={"r"}
                        roles={this.props.authUser ? this.props.authUser.roles : []}
                        render={(props) => {
                            return (
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={() => this.view(record._id)}
                                >
                                    View
                                </Button>
                            );
                        }}
                    />
                    <AccessControl
                        resource={this.props.resourceName}
                        permissionNeeded={"u"}
                        roles={this.props.authUser ? this.props.authUser.roles : []}
                        render={(props) => {
                            return (
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={() => this.edit(record._id)}
                                >
                                    Edit
                                </Button>
                            );
                        }}
                    />

                    <AccessControl
                        resource={this.props.resourceName}
                        permissionNeeded={"d"}
                        roles={this.props.authUser ? this.props.authUser.roles : []}
                        render={(props) => {
                            return (
                                <Popconfirm
                                    title="Are you sure you want to delete this record?"
                                    onConfirm={() => {
                                        this.deleteResource(record._id);
                                    }}
                                    onCancel={this.cancelDelete}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        style={{ marginLeft: "10px" }}
                                        type="danger"
                                        size="small"
                                    >
                                        Delete
                                    </Button>
                                </Popconfirm>
                            );
                        }}
                    />
                </div>
            ),
        });
        // console.log(selectedColumns, columns);

        this.setState({
            visibleColumns: selectedColumns,
            columns,
        });
    };

    // clearAll = () => {
    //   this.props.saveResourceQuery(this.initialQueryState);
    //   this.fetchList();
    // };

    clearAll = () => {
        const clearQueryState = {
            sort: {
                field: "",
                order: "",
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            filters: {},
        };
        //this.props.saveResourceQuery(this.initialQueryState);
        this.props.saveResourceQuery(clearQueryState);
        this.fetchList();
    };

    fetchList = () => {
        this.props.getResource();
    };

    createResource = (values) => {
        const _values = Object.assign(values);
        if (_values.meter) {
            _values.meter = parseInt(values.meter, 10);
        }
        // if (!_values.quantity) {
        //   _values.quantity = 0;
        // }
        // if (!_values.rate) {
        //   _values.rate = 0;
        // }
        if (!_values.bowserAsset) {
            _values.bowserAsset = null;
        }
        this.props.createResource(_values);
    };

    updateResource = (values, id) => {
        const _values = Object.assign(values);
        if (_values.meter) {
            _values.meter = parseInt(values.meter, 10);
        }
        // if (_values.quantity) {
        //   _values.quantity = parseInt(values.quantity, 10);
        // }
        // if (_values.rate) {
        //   _values.rate = parseInt(values.rate, 10);
        // }
        if (!_values.bowserAsset) {
            _values.bowserAsset = null;
        }
        this.props.updateResource(values, id);
    };

    deleteResource = (id) => {
        this.props.deleteResource(id);
    };

    cancelDelete = () => {
        message.error("Cancelled");
    };

    create = () => {
        const { match } = this.props;
        this.props.history.push(`${match.url}/add`);
    };

    edit = (id) => {
        const { match } = this.props;
        this.props.history.push(`${match.url}/edit/${id}`);
    };

    view = (id) => {
        const { match } = this.props;
        this.props.history.push(`${match.url}/view/${id}`);
    };

    downloadToCSV = () => {
        const columns = [];
        this.state.columns.map(
            (column) =>
                column.title !== "Action" && columns.push(_.camelCase(column.title)),
        );
        columns.push('isFaultyMeter')
        this.props.getResourceForDownload(
            JSON.stringify(columns),
            this.props.filters,
            "Fuel",
        );
    };

    generateReport = (values) => {
        this.props.fetchFuelReportData(values);
    };

    render() {
        const {
            match,
            data,
            resource,
            edit,
            fetchResource,
            loading: commonLoading,
            dataLoading,
            filters,
            modules,
            authUser,
            resourceName,
            reportData,
        } = this.props;
        const { columns, visibleColumns } = this.state;

        const loading = commonLoading || dataLoading;

        // console.log(data);

        faviconDynamicFunction(authUser);
        return (
            <div>
                {/* <h2>{sanitizeFieldName(resourceName)}</h2> */}

                <Switch>
                    <Route
                        path={`${match.url}`}
                        exact
                        render={() => (
                            <List
                                columns={columns}
                                visibleColumn={visibleColumns}
                                data={data}
                                clearFilter={this.clearAll}
                                filters={filters}
                                handleChange={this.handleChange}
                                columnChange={this.handleColumnChange}
                                downloadToCSV={this.downloadToCSV}
                                title={resourceName}
                                bulkDelete={this.props.bulkDelete}
                                size={"middle"}
                                create={this.create}
                                pagination={this.props.query.pagination}
                                loading={loading}
                                authUser={authUser}
                            />
                        )}
                    />

                    {/* jay */}
                    <Route
                        path={`${match.url}/add`}
                        render={(props) => (
                            <Refuel
                                assetFilter={this.props.getFuelFormFilter}
                                filters={filters}
                                modules={modules}
                                title={"CREATE"}
                                resource={resourceName}
                                onChange={this.handleFormChange}
                                onSubmit={this.createResource}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    {/* <Route
                        path={`${match.url}/report`}
                        render={(props) => (
                            <MileageReport
                                data={{}}
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                reportData={reportData}
                                onChange={this.handleFormChange}
                                generateReport={this.generateReport}
                                clearReportData={this.props.clearReportData}
                                loading={loading}
                                {...props}
                            />
                        )}
                    /> */}

                    <Route
                        path={`${match.url}/mileage-report`}
                        render={(props) => (
                            <AssetMileageReport
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/summery-report`}
                        render={(props) => (
                            <FuelSummeryReport
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/refuel-report`}
                        render={(props) => (
                            <RefuelReport
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/edit/:id`}
                        render={(props) => (
                            <Refuel
                                data={edit}
                                assetFilter={this.props.getFuelFormFilter}
                                filters={filters}
                                modules={modules}
                                title={"EDIT"}
                                resource={resourceName}
                                onChange={this.handleFormChange}
                                onSubmit={this.updateResource}
                                loading={loading}
                                fetch={fetchResource}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/view/:id`}
                        render={(props) => (
                            <Refuel
                                data={edit}
                                assetFilter={this.props.getFuelFormFilter}
                                filters={filters}
                                modules={modules}
                                title={"VIEW"}
                                resource={resourceName}
                                onChange={this.handleFormChange}
                                onSubmit={this.updateResource}
                                loading={loading}
                                fetch={fetchResource}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/chart/:asset`}
                        render={(props) => (
                            <FuelChart
                                data={edit}
                                assetFilter={this.props.getFuelFormFilter}
                                filters={filters}
                                modules={modules}
                                title={"VIEW"}
                                resource={resourceName}
                                onChange={this.handleFormChange}
                                onSubmit={this.updateResource}
                                loading={loading}
                                fetch={fetchResource}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/fuel-group-chart`}
                        render={(props) => (
                            <GroupChart
                                // data={edit}
                                // assetFilter={this.props.getFuelFormFilter}
                                filters={filters}
                                modules={modules}
                                // title={"VIEW"}
                                resource={resourceName}
                                // onChange={this.handleFormChange}
                                // onSubmit={this.updateResource}
                                loading={loading}
                                // fetch={fetchResource}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/bowser-transaction-report/:bowser?/:fromDate?/:toDate?`}
                        render={(props) => (
                            <BowserTransactionReport
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path={`${match.url}/bowser-report`}
                        render={(props) => (
                            <BowserReport
                                filters={filters}
                                modules={modules}
                                title={"REPORT"}
                                resource={resourceName}
                                loading={loading}
                                {...props}
                            />
                        )}
                    />

                    {/*
                      Fuel Stock & Issue Report — self-contained: it fetches
                      /fuel/bowser-report and /fuel/mileage-report itself (once
                      per Fetch, in parallel) and derives everything client-side,
                      so it needs no redux data or props from this container.
                    */}
                    <Route
                        path={`${match.url}/stock-issue-report`}
                        render={() => <FuelStockIssueReport />}
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = ({ auth, fuel, commonData }) => {
    return {
        authUser: auth.authUser,
        total: fuel.total,
        data: fuel.resources,
        resource: fuel.resource,
        edit: fuel.edit,
        query: fuel.query,
        reportData: fuel.reports,
        loading: commonData.loading,
        dataLoading: commonData.dataLoading,
        filters: commonData.filters,
        modules: commonData.modules,
        assetData: commonData.relationshipSearch,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getResource,
        getResourceForDownload,
        createResource,
        fetchResource,
        updateResource,
        deleteResource,
        saveResourceQuery,
        fetchFilter,
        fetchFuelReportData,
        fetchRelationshipSearchData,
        bulkDelete,
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Fuel);
